import React from 'react';
import { productShortName } from '../data/offer';
export function Footer() {
  return <footer className="bg-earth-700 text-earth-100" data-id="element-92" data-mp="3gfsmscqd8umz">
      <div className="h-1.5 w-full bg-gold-500" aria-hidden="true" data-id="element-93" data-mp="3ggk90wy2pg0l" />
      <div className="mx-auto max-w-3xl px-4 py-10 text-center" data-id="element-94" data-mp="32ovuyo49khgz">
        <p className="font-display text-lg font-extrabold uppercase text-cream" data-id="element-95" data-mp="36p6cmy1f4wbo">{productShortName}</p>
        <p className="mt-3 text-sm" data-id="element-96" data-mp="3ufa5cad2jbnw">Created by mining education specialists, for educators worldwide.</p>
        <p className="mt-6 border-t border-earth-100/20 pt-6 text-xs" data-id="element-97" data-mp="3990wknlzgb8">
          © 2026 {productShortName} — All rights reserved.
        </p>
      </div>
    </footer>;
}